import { useTranslation } from 'react-i18next';
import { Empty } from 'antd';
import HazardSymbol from '@client/components/ui/HazardSymbol';
import { HtmlContent } from '@client/utils/html_content';

const sanitizeValue = (value) => {
  if (value === null || value === undefined || value === 'null' || value === 'undefined') return '';
  return value;
};

const InformationTable = ({ data, leftTitle = '', rightTitle = '', showReferences = false }) => {
  const { t } = useTranslation('active-substance-details');

  if (!data || data.length === 0) {
    return (
      <div className="w-full bg-white mt-[32px] flex flex-col gap-[16px]">
        {leftTitle && rightTitle && (
          <div className="bg-[#E9F1D9] rounded-[16px] px-[24px] py-[24px] hidden sm:flex gap-[32px]">
            <span className="font-bold flex-1">{leftTitle}</span>
            <span className="font-bold flex-2">{rightTitle}</span>
          </div>
        )}
        <div className="bg-[#F5F5F5] rounded-[16px] px-[24px] py-[32px] flex justify-center">
          <Empty
            description="Aucune donnée disponible"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white mt-[32px] flex flex-col gap-[16px]">
      {leftTitle && rightTitle && (
        <div className="bg-[#E9F1D9] rounded-[16px] px-[24px] py-[24px] hidden sm:flex gap-[32px]">
          <span className="font-bold flex-1">{leftTitle}</span>
          <span className="font-bold flex-2">{rightTitle}</span>
        </div>
      )}

      <div className="flex flex-col gap-4">
        {data.map((item, index) => (
          <div
            key={index}
            className="bg-[#F5F5F5] gap-[32px] rounded-[16px] px-3 sm:px-6 py-4 sm:py-6 flex flex-col sm:flex-row sm:justify-between sm:items-start"
          >
            {/* Left column - Criteria */}
            <div className="flex-1">
              {/* Mobile label - only show on mobile when titles are present */}
              {leftTitle && (
                <div className="block sm:hidden font-bold text-[#000] mb-1">
                  {leftTitle}
                </div>
              )}
              <div className="text-[#5B8C00] font-bold" style={item.criteriaStyle || undefined}>
                {item.icon ? (
                  // With icon - display icon and text inline
                  <div className="flex items-center gap-2">
                    {typeof item.icon === 'string' ? (
                      <img
                        src={item.icon}
                        alt={item.criteria}
                        className="w-6 h-6 object-contain"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <span className="text-xl">{item.icon}</span>
                    )}
                    <HtmlContent html={item.criteria} />
                  </div>
                ) : typeof item.criteria === 'object' &&
                  item.criteria.type === 'image' ? (
                  // Legacy support for image type criteria
                  <div className="flex items-center gap-3">
                    <img
                      src={item.criteria.src}
                      alt={item.criteria.alt}
                      className="w-10 h-10 object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                    <span>
                      {item.criteria.fallbackText}
                    </span>
                  </div>
                ) : (
                  // Text only
                  <HtmlContent html={item.criteria} />
                )}
              </div>
            </div>

            {/* Right column - Value and References */}
            <div className="flex-2">
              {/* Mobile label - only show on mobile when titles are present */}
              {rightTitle && (
                <div className="block sm:hidden font-bold text-[#000] mb-1 mt-3">
                  {rightTitle}
                </div>
              )}
              <div className="text-[#000] mb-3 sm:mb-4">
                {item.hasSymbol && item.symbol ? (
                  <HazardSymbol symbol={item.symbol} size={32} />
                ) : (
                  <HtmlContent html={sanitizeValue(item.value)} />
                )}
              </div>

              {showReferences && item.references && (
                <div className="text-sm text-[#000] bg-white p-[24px] rounded-[8px]">
                  <div className='mb-[8px]'>{t('Références:')}</div>
                  {item.references.map((ref, refIndex) => (
                    <div key={refIndex} className="mb-3">
                      <span>
                        <HtmlContent html={ref?.text || ''} />{' '}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default InformationTable;
